import Company from './Company.page';

export default Company;